import React from 'react';
import { FadeLayer } from './../../styled';
import { Image, VideoWrapper } from './styled';
import assset from './step-4-placeholder.png';

const wrapperStyle = {
  position: 'relative',
  display: 'flex',
  width: '100%',
  height: '100%'
};

class Step4 extends React.Component {
  constructor() {
    super();
    this.videoListener = this.videoListener.bind(this);
  }

  videoListener = () => {
    this.props.selectStep(5);
  };

  render() {
    if (this.props.currentStep !== 4) {
      return null;
    }
    return (
      <div style={wrapperStyle}>
        <FadeLayer />
        <VideoWrapper>
          {this.props.navigated
            ? <img
                src="https://cdn.auth0.com/website/homepage/04-customization.png"
                alt="Customization"
              />
            : <video
                muted={'true'}
                onEnded={this.videoListener}
                autoPlay="true"
                src="https://videos.ctfassets.net/2ntc334xpx65/pwg6gpYMr688QQiS6yMAO/07a18fad0fbf2eb93d37d15a2f8ae087/04_Customization.mp4"
              />}
        </VideoWrapper>
      </div>
    );
  }
}

export default Step4;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/Step4/Step4.js